/** Small async helpers used by collectors. */

/** Resolve a promise but never reject — returns `fallback` on error/timeout. */
export async function safe<T>(p: Promise<T> | T, fallback: T, timeoutMs = 0): Promise<T> {
  try {
    if (timeoutMs > 0) {
      return await Promise.race([
        Promise.resolve(p),
        new Promise<T>((resolve) => setTimeout(() => resolve(fallback), timeoutMs)),
      ]);
    }
    return await Promise.resolve(p);
  } catch {
    return fallback;
  }
}

/** Run a synchronous collector, swallowing any error. */
export function tryCatch<T>(fn: () => T, fallback: T): T {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

export const now = (): number =>
  typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
